// externals
import type { Reducer } from 'redux';

// libraries
import type { DealerState } from '@makemydeal/dr-dash-types';
import { initActionTypes } from '@makemydeal/dr-shared-store';
import { SOCKET_EVENT_IGNORED, SOCKET_EVENT_RECEIVED } from '../actionTypes/socketActionTypes';
import { CREDIT_APP_SEARCH_MERGE_DEAL } from '../actionTypes/creditAppSearchActionTypes';

const { INIT_PENCIL_SUCCESS, INIT_PENCIL_INVALID_DEAL } = initActionTypes;
export const UPDATE_DEALER = 'UPDATE_DEALER';

export type DealerReducer = Reducer<DealerState>;

export const reducer: DealerReducer = (state: Partial<DealerState> = {}, action: any) => {
    switch (action.type) {
        case INIT_PENCIL_SUCCESS: {
            return {
                ...state,
                ...action.payload.dealer,
                inventoryAssistantEnabled: action.payload.dealer?.inventoryAssistantEnabled === true
            };
        }
        case INIT_PENCIL_INVALID_DEAL: {
            const hasDealer = !!(action.payload.dealer && action.payload.dealer.dealerId);
            return {
                ...state,
                ...(hasDealer ? action.payload.dealer : {}),
                inventoryAssistantEnabled: hasDealer && action.payload.dealer.inventoryAssistantEnabled === true
            };
        }
        case UPDATE_DEALER: {
            /**
             * This will update the dealer information in the store when user selects a different dealer from the OpenDeal Dealership dropdown
             */
            return {
                ...state,
                ...action.payload,
                inventoryAssistantEnabled: false
            };
        }
        case SOCKET_EVENT_RECEIVED:
        case SOCKET_EVENT_IGNORED: {
            const event = action.payload;
            const partnerId = event?.data?.coxAutoReferences?.dealRefIdPartner?.partnerCode;
            const partnerDealerId = event?.data?.coxAutoReferences?.dealRefIdPartner?.partnerDealerId;

            if (event?.topic === 'dealXgPatch' && partnerId && partnerId !== state.partnerId) {
                return { ...state, partnerId, partnerDealerId };
            }
            return state;
        }
        case CREDIT_APP_SEARCH_MERGE_DEAL: {
            const dealRefIdPartner = action.payload.coxAutoReferences?.dealRefIdPartner;

            return {
                ...state,
                partnerId: dealRefIdPartner?.partnerCode,
                partnerDealerId: dealRefIdPartner?.partnerDealerId
            };
        }
        default: {
            return state;
        }
    }
};
